import b from 'b_';
import cx from 'classnames';
import { SimpleCallback } from 'platform-components';
import { mediaQueryResolver, SCREEN_SIZE, WithMediaQueryResolverProps } from 'platform-components/hocs';
import React from 'react';

import { LessonPermissions } from 'utils/lesson';

// @ts-ignore
import BREAKPOINTS from '../../design/breakpoints.scss';
import { LessonCopyLink } from '../lesson-copy-link/lesson-copy-link';
import { LessonThreeDots } from '../lesson-three-dots/lesson-three-dots';

import { SCREEN_QUERY } from './constants';

interface OwnProps {
    childLink: string;
    disabled: boolean;
    mix?: string;
    onClick?: SimpleCallback;
    onLessonDelete: SimpleCallback;
    onLessonCopy: SimpleCallback;
    onLessonClose: SimpleCallback;
    lessonPermissions: LessonPermissions;
    clessonId: number;
    courseId: number | null;
    subscriptionSlug: string | null;
}

interface HOCProps extends WithMediaQueryResolverProps {}

export interface Props extends OwnProps, HOCProps {}

export class LessonSettings extends React.Component<Props> {
    render() {
        const {
            mix,
            childLink,
            disabled,
            onClick,
            onLessonDelete,
            onLessonCopy,
            onLessonClose,
            lessonPermissions,
            clessonId,
            courseId,
            screenSize,
        } = this.props;
        const isMobile = screenSize === SCREEN_SIZE.SMALL;
        const shouldShowCopyLessonLinkControl = lessonPermissions.isCopyLessonLinkAvailable && !isMobile;

        if (Object.values(lessonPermissions).every((permisson) => !permisson) && !shouldShowCopyLessonLinkControl) {
            return <div className={b('lesson-settings', { empty: true })} />;
        }

        return (
            <div className={cx('lesson-settings', mix)}>
                {shouldShowCopyLessonLinkControl && <LessonCopyLink childLink={childLink} clessonId={clessonId} />}
                <LessonThreeDots
                    childLink={childLink}
                    clessonId={clessonId}
                    courseId={courseId}
                    disabled={disabled}
                    lessonPermissions={lessonPermissions}
                    onClick={onClick}
                    onLessonClose={onLessonClose}
                    onLessonCopy={onLessonCopy}
                    onLessonDelete={onLessonDelete}
                />
            </div>
        );
    }
}

const wrapped = mediaQueryResolver([], BREAKPOINTS, SCREEN_QUERY)(LessonSettings) as React.ComponentType<OwnProps>;
wrapped.displayName = 'LessonSettings';

export default wrapped;
